import { SIDEBAR } from '../type'

const initialState = {
  data: null,
  isLoading: false,
  error: null,
  isExpanded: true,
}

export function schemaSidebar(state = initialState, action) {
  switch (action.type) {
    case SIDEBAR.REQUEST: {
      return { ...state, isLoading: true, error: null }
    }
    case SIDEBAR.FAILURE: {
      return { ...state, isLoading: false, error: action.error }
    }
    case SIDEBAR.SUCCESS: {
      return { ...state, isLoading: false, error: null, data: action.payload }
    }
    case SIDEBAR.SET_IS_EXPANDED: {
      return { ...state, isExpanded: action.payload }
    }
    default:
      return state
  }
}
